const blockedList = {
  blockedIds: {
    mcom: {
      categoryIds: [
        '297864',
        '62990',
        '62580',
        '19488',
        '236010',
        '19295',
        '63220',
        '64003',
        '62991',
        '50375',
        '237729',
        '237731',
        '62601',
        '255156',
        '68033',
        '293858',
        '62605',
        '237708',
        '25607',
        '232298',
        '25611',
        '62581',
        '70265',
        '63224',
        '14728',
        '59564',
        '240627',
        '233815',
        '63266',
        '62584',
        '63254',
        '255980',
        '260266',
        '69160',
        '233813',
        '27726',
        '62588',
        '80378',
        '63066',
        '63222',
        '70539',
        '62596',
        '232306',
        '305661',
        '62577',
        '233809',
        '121443',
        '62992',
        '67632',
        '62574',
        '198960',
        '14355',
        '27932',
        '237351',
        '63270',
        '62993',
        '34086',
        '355475',
        '349965',
        '349866',
        '65571',
        '235510',
        '228501',
        '63221',
        '25612',
        '58156',
        '146446',
        '233810',
        '62598',
        '62583',
        '305061',
        '209665',
        '220793',
        '62139',
        '157042',
        '305257',
        '62483',
        '239508',
        '63913',
        '62595',
        '58063',
        '70266',
        '233808',
        '305656',
        '236009',
        '31456',
        '17660',
        '62604',
        '62613',
        '59096',
        '237733',
        '121442',
        '69571',
        '131642',
        '70527',
        '59304',
        '235508',
        '212454',
        '63655',
        '63258',
        '141853',
        '240623',
        '30170',
        '146445',
        '43770',
        '70264',
        '62600',
        '305658',
        '239509',
        '62578',
        '201658',
        '62594',
        '233812',
        '27931',
        '61916',
        '200877',
        '65994',
        '62138',
        '62576',
        '63218',
        '52273',
        '176951',
        '305659',
        '287556',
        '62603',
        '232304',
        '66029',
        '303267',
        '63225',
        '238021',
        '62587',
        '62553',
        '104642',
        '237730',
        '58155',
        '305657',
        '3485',
        '52282',
        '55772',
        '63268',
        '63257',
        '27939',
        '62582',
        '75817',
        '232305',
        '146444',
        '70268',
        '62599',
        '305064',
        '44201',
        '240626',
        '210294',
        '57374',
        '305062',
        '36272',
        '358273',
        '355185',
        '358366',
        '358367',
        '358365',
        '358274',
        '355183',
        '355666',
        '358271',
        '355474',
        '355182',
        '62589',
        '238727',
        '64019',
        '50376',
        '60098',
        '303268',
        '145649',
        '62597',
        '70267',
        '211353',
        '63223',
        '236011',
        '62602',
        '200876',
        '5204',
        '62586',
        '70540',
        '233811',
        '63685',
        '198958',
        '63260',
        '62606',
        '71077',
        '233110',
        '3304',
        '237732',
        '232291',
        '62575',
        '198961',
        '62608',
        '62585',
        '283160',
        '8376',
        '236008',
        '177451',
        '240624',
        '31746',
        '305660',
        '14730',
        '66525',
        '62579',
        '255982',
        '63256',
        '63266',
        '67632',
        '67632',
        '28295',
        '55760',
        'onsite_search',
        '303267',
        '305661',
        '305064',
        '305061',
        '305660',
        '305658',
        '305257',
        '303268',
        '305063',
        '305256',
        '305659',
        '305657',
        '305656',
        '305062',
        '293156',
        '69186',
        '59782',
        '59561',
        '59686',
        '131651',
        '131650',
        '131648',
        '131643',
        '131645',
        '181253',
        '313256',
        '313257',
        '287556',
        '358369',
        '358368',
        '95543',
        '198352',
        '266458',
        '70299',
        '266571',
        '198652',
        '250356',
        '283160',
        '261372',
        '255792',
        '237714',
        '219023',
        '208651',
        '200872',
        '44201',
        '25605',
        '62483',
        '117547',
        '94943',
        '66384',
        '76398',
        '72701',
        '72109',
        '71563',
        '63536',
        '63165',
        '59559',
        '59562',
        '79923',
        '78456',
        '257756',
        '57924',
        '71659',
        '221896',
        '347365',
        '67045',
        '180742',
        '345075',
        '52387',
        '238021',
        '31456',
        '36868',
        '62553',
        '70623',
        '60098',
        '32840',
        '25607',
        '19247',
        '31711',
        '334356',
        '343156',
        '355665',
        '292760',
      ],
      searchKeywords: [
        'lauren',
        'kors',
        'tom ford',
        'chanel',
        'dior',
        'hermes',
        'hermès',
        'tiffany',
        'gucci',
        'ralph lauren home',
        'ralph lauren baby',
        'ralph lauren kids',
        'polo ralph lauren',
        'ralph lauren home',
        'lauren ralph lauren home',
        'polo women',
        'polo ralph lauren women',
        'polo baby',
        'polo kids',
        'polo ralph lauren men',
        'polo ralph lauren big boy',
        'polo ralph lauren big girl',
      ],
      pdpBlockedBrands: [
        'lauren',
        'ralph lauren',
        'lauren ralph lauren',
        'tom ford',
        'dior',
        'kors',
        'tiffany & co.',
        'tiffany and co.',
        'chanel',
        'hermes',
        'hermand egrave;s',
        'herm&egrave;s',
        'hermès',
        'gucci',
      ],
      brandExceptions: ['laurent'],
    },
    bcom: {
      categoryIds: [
        '1001734', '1079259', '1063561', '1109366', '1001280', '1003114', '1071359', '1003851',
        '1001283', '1001107', '1003158', '1004212', '1002107', '1001282', '1085759', '1001077',
        '1109063', '1001075', '1002106', '1001105', '1001022', '1022159', '1004060', '1002099',
        '1101059', '1100160', '1081559', '1003245', '1001152', '1000528', '1001021', '1002104',
        '1001019', '1000926', '1116461', '1018460', '1001279', '1088459', '1004007', '1004215',
        '1001154', '1001078', '1109065', '1001020', '1109066', '1002100', '1001104', '1004011',
        '1001070', '1053263', '1004760', '1115461', '1004716', '1004936', '1004058', '1001284',
        '1002108', '1004056', '1003115', '1002102', '1100759', '1001286', '1001155', '1002095',
        '1001076', '1003161', '1100860', '1109365', '1001071', '1002105', '1081259', '1001023',
        '1003568', '1105168', '1004057', '1002109', '1001288', '1004008', '1001151', '1000530',
        '1071659', '1001110', '1003159', '1039659', '1003154', '1001153', '1001064', '1002097',
        '1001072', '1004010', '1001103', '1001281', '1001073', '1018459', '1040459', '1004209',
        '1002103', '1001308', '1002101', '1002474', '1001109', '1003160', '1002098', '1001108',
        '1001074', '1116159', '1074660', '1005320', '1105159', '1100159', '1001285', '1003247',
        '1050759', '1109067', '1001102', '1110660', '1109062', '1002111', '1162760', '1208359',
        '1227960', '1265908', '1265899', '1265904', '1265903', '1265907', '1265900', '1265901',
      ],
      searchKeywords: [
        'ralph lauren', 'baccarat rouge', 'chanel', 'yurman',
        'saint laurent jewelry accessories', 'saint laurent', 'hermes', 'ysl',
        'laurent', 'yves saint laurent beauty', 'lauren', 'moncler',
        'david yurman', 'heuer', 'tag heuer', 'gucci',
      ],
      pdpBlockedBrands: [
        'david yurman',
        'hermes',
        'herm&egrave;s',
        'hermand egrave;s',
        'yves saint laurent',
        'saint laurent',
        'moncler',
        'gucci',
        'lauren',
        'ralph lauren',
        'polo ralph lauren',
        'tag heuer',
        'ysl',
        'chanel',
        'dyson',
      ],
    },
  },
};
export default blockedList;
